import { render, staticRenderFns } from "./Atenciónalcliente.vue?vue&type=template&id=422d5bcd&"
import script from "./Atenciónalcliente.vue?vue&type=script&lang=ts&"
export * from "./Atenciónalcliente.vue?vue&type=script&lang=ts&"
import style0 from "./Atenciónalcliente.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports